import { Injectable } from '@angular/core';
import {HttpHelperService} from "./http-helper.service";
import {QuizResult} from "./models/quizes/QuizResult";
import {QuizViewModel} from "./models/quizes/QuizViewModel";

@Injectable({
  providedIn: 'root'
})
export class QuizService {

  constructor(private httpService: HttpHelperService) { }
  public getQuiz(activityId: string): Promise<QuizResult> {
    return new Promise<QuizResult>((resolve, reject) => {
      this.httpService.get<QuizResult>(`quiz/${activityId}`)
        .then(r => resolve(new QuizResult(r)))
        .catch(e => reject(e));
    })
  }
  public saveQuiz(activityId: string, answerId: string): Promise<QuizResult> {
    return new Promise<QuizResult>((resolve, reject) => {
      this.httpService.post<QuizResult>("quiz", { activityId: activityId, answerId: answerId })
        .then(r => resolve(new QuizResult(r)))
        .catch(e => reject(e))
    });
  }
}
